import {
  Button,
  DeleteIcon,
  GridColumn,
  GridRow,
  GroupedGroupOption,
  GroupPicker,
  Select,
  SelectOptionType,
} from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { SingleValue } from 'react-select';

type LessonClassesFormItemProps = {
  index: number;
  disabled: boolean;
  groups: string[];
  classUuid: string;
  className: string;
  classOptions: SelectOptionType[];
  groupOptions: GroupedGroupOption[];
  onClassChange: (classUuid: string) => void;
  onGroupsChange: (groups: string[]) => void;
  onDelete: () => void;
};

export const LessonClassesFormItem = ({
  index,
  disabled,
  classUuid,
  className,
  groups,
  classOptions,
  groupOptions,
  onClassChange,
  onGroupsChange,
  onDelete,
}: LessonClassesFormItemProps) => {
  const { t } = useTranslation();

  const currentGroupOptions = groupOptions.find((option) => option.options.some((o) => groups.includes(o.value)));

  return (
    <GridRow spacingBottom='s' spacingTop='none'>
      <GridColumn width={5}>
        <Select
          readonly={disabled}
          isSearchable
          onChange={async (option) => {
            const opt = option as SingleValue<SelectOptionType>;
            onClassChange(opt?.value as string);
          }}
          options={classOptions}
          label={t('classes.title', { count: 2 })}
          name={`lessonClasses.${index}.class`}
          value={classOptions.find((option) => option.value === classUuid)}
        />
      </GridColumn>
      <GridColumn width={5}>
        <div style={{ width: '100%' }}>
          <GroupPicker
            readonly={disabled}
            name={`lessonClasses.${index}.groups`}
            label={t('common.group_other')}
            disabled={disabled}
            options={groupOptions}
            onChange={async (multiValue) => {
              onGroupsChange(multiValue.map((option) => option.value));
            }}
            value={currentGroupOptions?.options.filter((option) => groups.includes(option.value)) ?? []}
            dropdownHeader={t('classGroups.divisionsListTitle', { class: className })}
            fitMenuToOptions={groupOptions.length !== 0}
          />
        </div>
      </GridColumn>
      <GridColumn width={2} className='mt-5' align='end'>
        <Button hierarchy='tertiary' disabled={disabled} onClick={onDelete} icon={<DeleteIcon />} />
      </GridColumn>
    </GridRow>
  );
};
